import { Component, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { to64decode } from 'src/app/helpers/base64';
import { localStorageToJsonAsync } from 'src/app/helpers/cookieToJson';
import { sortArrayOfObjects } from 'src/app/helpers/sortArrayOfObjects';
import { systemPermissionsNew } from 'src/app/helpers/systemPermissions';
import { addAlert, apiOfflineAsync } from 'src/app/layouts/pages/pages.component';
import { CorporationService } from 'src/app/services/corporation/corporation.service';
import { getLanguageCookie } from 'src/assets/language';
import { v4 } from 'uuid';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent {
  @Input() parameters: any = {}
  @Input() dimensions: any = {}

  selectedFlag: any = {
    lang: 'en',
    file: 'us.svg'
  };

  dataSource!: MatTableDataSource<any>;
  displayedColumns: string[] = ['name', 'email', 'action'];
  currentPage = 1;
  currentPageReq = 1;
  itemsPerPage = 10;

  is_new_contact: boolean = true;
  createType: boolean = false

  currentContact: any = {}
  searchType: string = ''
  searchArea: string = ''
  searchFunction: string = ''
  searchContact: string = ''
  contactTypeArray: any[] = []

  areaArray: any[] = []
  functionArray: any[] = []
  contactsNivel3: any[] = []

  newType = { name: '' };
  properties: any

  constructor(private corporationService: CorporationService) {
    this.dataSource = new MatTableDataSource();
  }

  async ngOnInit() {
    this.properties = await localStorageToJsonAsync()
    this.dataSource.data = this.parameters.item.contacts ?? []
    this.newContact();

    this.initContactsNivel3()

    await this.getCorporationTypeContact()
  }

  findParentLevel3(files: any[], node: any): any {
    for (const item of files) {
      if (item.uuid === (node.master || this.parameters.parentUuid) && item.level === 3) {
        return item;
      }
      if (item.children) {
        const found = this.findParentLevel3(item.children, node);
        if (found) return found;
      }
    }
    return null;
  }

  getNames(name: any) {
    return name[to64decode(localStorage.getItem('language')).lang]
  }

  getLanguages(file: string) {
    return getLanguageCookie(file, localStorage.getItem('language'))
  }

  isData() {
    return this.dataSource.data.length > 0
  }

  getDisplayedRows(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.dataSource.data.slice(startIndex, endIndex);
  }

  getColumns() {
    return this.displayedColumns.slice(1)
  }

  getItemsPerPage() {
    return this.itemsPerPage
  }

  getCurrentPages(): number {
    return this.currentPage
  }

  choseItemsPage(number: number) {
    this.itemsPerPage = number;
    this.getDisplayedRows()
  }

  onPageChange(newPage: number, text: string): void {
    this.currentPage = newPage;
  }

  getTotalPages(): number {
    return Math.ceil(this.dataSource.data.length / this.itemsPerPage);
  }

  async checkValue() {
    let total = this.getTotalPages()
    if (this.currentPage > total) this.currentPage = total;
  }

  async selectContact(item: any) {
    this.currentContact = { ...item }
    this.is_new_contact = false;
  }

  async newContact() {
    this.currentContact = {
      uuid: v4(),
      name: '',
      type: '',
      email: '',
      phone: '',
      area: '',
      function: ''
    };

    this.is_new_contact = true;
  }

  async saveContact() {
    let inputs: any = []

    if (!this.parameters.isEdit) {
      return
    }

    if (this.parameters.item.level == 4 && !this.currentContact.name) {
      inputs.push('Name')
      addAlert('orange', `${this.getLanguages('mandatoryField')}${inputs.join(`, `)}`)
      return
    }

    if (!this.currentContact.name || this.currentContact.name == '') {
      inputs.push('Name')
    }

    if (!this.currentContact.email || this.currentContact.email == '') {
      inputs.push('email')
    }

    if (inputs.length > 0) {
      addAlert('orange', `${this.getLanguages('mandatoryField')}${inputs.join(`, `)}`)
      return
    }

    if (this.is_new_contact) {
      this.dataSource.data.push(this.currentContact)
      if (this.parameters.item.level == 4) {
        this.contactsNivel3 = this.contactsNivel3.filter((contact: any) =>
          !this.dataSource.data.some((existingContact: any) => existingContact.uuid === contact.uuid)
        );
      }
    } else {
      this.dataSource.data.find((item: any, index: number) => {
        if (item.uuid == this.currentContact.uuid) {
          this.dataSource.data[index] = this.currentContact
        }

        if (this.parameters.item.level == 4) {
          this.dataSource.data[index] = this.currentContact
          this.initContactsNivel3()
        }
      })
    }

    await this.newContact()
  }

  async deleteContact(uuid: string) {
    this.dataSource.data = this.dataSource.data.filter(item => item.uuid !== uuid);
    this.parameters.item.contacts = this.dataSource.data
    this.initContactsNivel3()
    await this.newContact()
  }

  initContactsNivel3() {
    if (this.parameters.item.level === 4) {
      const parentLevel3 = this.findParentLevel3(this.parameters.files, this.parameters.item);
      this.contactsNivel3 = parentLevel3?.contacts?.filter((contact: any) =>
        !this.dataSource.data.some((existingContact: any) => existingContact.uuid === contact.uuid)
      ) ?? [];
    }
  }

  choseType(item: any, type: any) {
    if (type.name == "New +") {
      this.createType = true;
      return
    }
    item.type = type.name
  }

  choseArea(item: any, area: any) {
    item.area = area.name
  }

  choseContact(item: any, contact: any) {
    item.name = contact.name
    this.currentContact = { ...contact }
  }

  choseFunction(item: any, role: any) {
    item.function = role.name
  }

  async setCorporationTypeContact() {
    let flag = false;

    this.contactTypeArray.forEach((item: any) => {
      if (item.name == this.newType.name) {
        addAlert('orange', this.getLanguages('businessSolution/modal/contacts/errors/typeContact'))
        flag = true
        return
      }
    });

    if (flag) {
      return
    }

    if (this.newType.name == 'New +') {
      addAlert('danger', this.getLanguages('auth/alert/nameReservedWord'))
      return
    }

    try {
      const response: any = await this.corporationService.setCorporationTypeContact(this.newType);
      if (response && [201, 202].includes(response.status)) {
        addAlert('success', response.message)
        await this.getCorporationTypeContact();
      } else {
        addAlert('danger', response.message)
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
    this.createType = false;
    this.newType.name = ''
  }

  async initCorporationLandscape() {
    this.contactTypeArray = []
    if (systemPermissionsNew('settings', 'corporations')) {
      this.contactTypeArray.push({ name: 'New +' })
    }
    this.contactTypeArray.push(...sortArrayOfObjects(this.parameters.optionsArray.contactsTypeEnum))
    this.areaArray.push(...sortArrayOfObjects(this.parameters.optionsArray.contactsAreaEnum))
    this.functionArray.push(...sortArrayOfObjects(this.parameters.optionsArray.contactsFunctionEnum))
  }

  async getCorporationTypeContact(event?: any) {
    try {
      const response: any = await this.corporationService.getCorporationTypeContact();
      if (response && response.data) {
        await this.initCorporationLandscape();
        this.contactTypeArray.push(...sortArrayOfObjects(response.data))

      } else {
        throw new Error('Erro ao consultar corporations landscape!\nConsulta o administrador do sistema!');
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  formatPhoneNumber(event: any): void {
    const input = event.target;
    let value = input.value.replace(/\D/g, ''); // Remove todos os caracteres não numéricos

    if (value.length > 11) {
      value = value.substring(0, 11); // Limita o número de caracteres a 11
    }

    const formattedValue = value.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
    input.value = formattedValue;
    this.currentContact.phone = formattedValue;
  }
}
